import React from 'react';
import { Box } from '../Box/Box';
import { TextLoading } from '../Text/Text.loading';
import { StatSize } from './Stat';

interface Props {
  size?: StatSize;
}

export const StatLoading: React.FC<Props> = ({ size = 'large' }) => {
  return (
    <Box display="flex" flexDirection="column">
      <TextLoading width={100} />

      <TextLoading width={200} height={size === 'large' ? 'h2' : 'h4'} />
    </Box>
  );
};
